import materialUI from "material-UI";
import styled from "styled-components";
import colors from "../../../../constants/color";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const BodyContainer = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px 12px 12px;
  margin-top: 24px;
`;

export const Row = styled.div`
  width: 100%;
  gap: 12px;
  display: flex;
  flex-direction: row;
  padding-top: 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.h1`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  color: #333333;
`;

export const TitleInfo = styled.h1`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  color: #424248;
  margin-bottom: 4px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 4px;
  label {
    display: none;
  }

  .MuiInputBase-root {
    border-radius: 8px;
    height: 44px;
    margin: 0;
    padding-top: 2px;
  }
  .MuiInputBase-input {
    height: 44px;
  }
  .MuiTypography-root {
    padding-top: 1px;
  }
  .MuiOutlinedInput-input {
    padding: 0 12px;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 4px;
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: #f2f4f8; /* Mantemos essa linha para consistência */
    input {
      color: ${colors.grey1};
    }
  }
  .MuiInputBase-root.Mui-disabled {
    background-color: #f2f4f8 !important; /* Define a cor de fundo vermelha para campos desativados */
    input {
      color: ${colors.grey1} !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 40px;
  background: ${colors.primary};
  border-radius: 8px;
  border: none;
  color: #ffffff;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.01em;
  cursor: pointer;
`;

export const ButtonVincular = styled(Button)`
  height: 36px;
  width: 120px;
  margin-bottom: 2px;
  border-radius: 4px;
  background-color: ${colors.primary};
  color: white;
  :disabled {
    opacity: 50%;
    color: white;
    cursor: not-allowed;
  }
`;

export const StatusBadge = styled.span<{ status?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin-left: 8px;
  white-space: nowrap;
  color: ${({ status }) => {
    if (status === "Aprovada") return "#2E7D32";
    if (status === "Reprovada") return "#D32F2F";
    if (status?.includes("mediante")) return "#ED6C02";
    return colors.grey1;
  }};
  background-color: ${({ status }) => {
    if (status === "Aprovada") return "#E8F5E9";
    if (status === "Reprovada") return "#FFF0F0";
    if (status?.includes("mediante")) return "#FFF4E5";
    return "#F5F5F5";
  }};
`;

export const WarningMessage = styled.div`
  display: flex;
  align-items: center;
  color: #ed6c02cc;
  font-size: 12px;
  margin-top: 4px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: -0.01em;
  text-align: left;
`;
